import axiosConfig from '../data/utils/axiosConfigInstance';

const videoApi = {
	// --------------Saved video api----------------
	getAllSavedVideoIds: userId => axiosConfig.post(`/saved/videos`, { userId }),
	getVideoData: videoId => axiosConfig.post(`/vimeo/video/details`, { videoId }),
	addVideo: formData => axiosConfig.post(`/videos`, { formData }),
	uploadVideo: payload => axiosConfig.post(`/admin/upload-video`, payload),
};

export default videoApi;
